<template>
  <div class="profile_group_list">
    <div class="wrap-device-list_bg">
      <div
          :class="filters_state ? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
          @click="toggleFiltersState"
      >
        <span class="mdi" :class="filters_state ? 'mdi-filter-remove' : 'mdi-filter'" />
        <span class="main_fiters_toggler_text">
          {{ filters_state ? translate('filter.hide') : translate('filter.show') }}
        </span>
      </div>
      <div class="header" :class="filters_state ? 'shown' : 'hidden'">
        <div class="form_select">
          <fg-input
              v-model="filter.q"
              type="text"
              :placeholder="translate('search')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
              v-model="filter.client_id"
              :options="client_list"
              :multiple="false"
              :placeholder="translate('client.one')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>
    </div>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th class="w50" scope="col">ID</th>
            <th class="text-left" scope="col">{{ translate('simcard_profile_group.name') }}</th>
            <th scope="col">{{ translate('simcard_profile_group.group_type') }}</th>
            <th class="text-left" scope="col">{{ translate('client.one') }}</th>
            <th class="w100" scope="col">{{ translate('simcard_profile_group.members_count') }}</th>
            <th class="text-left" scope="col">{{ translate('simcard_profile_group.description') }}</th>
            <th scope="col">{{ translate('simcard_profile.ts_create') }}</th>
            <th scope="col">{{ translate('simcard_profile.ts_update') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load">
            <td><scale-loader /></td>
          </tr>
          <template v-else>
            <GroupListItem v-for="item in groups" :key="item.id" :item="item" />
            <tr v-if="!groups.length">
              <td>{{ translate('no_data') }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-if="total > filter.limit" class="pagination_controls">
      <button class="btn btn-info btn-fill" :disabled="load || filter.offset === 0" @click="change_page(filter.offset - filter.limit)">
        {{ translate('simcard_profile_group.previous') }}
      </button>
      <span>{{ filter.offset / filter.limit + 1 }}</span>
      <button class="btn btn-info btn-fill" :disabled="load || filter.offset + filter.limit >= total" @click="change_page(filter.offset + filter.limit)">
        {{ translate('simcard_profile_group.next') }}
      </button>
    </div>
  </div>
</template>

<script>
import GroupListItem from './Item/Index.vue'

export default {
  name: 'SimCardProfileGroupList',
  components: {
    GroupListItem
  },
  data() {
    return {
      groups: [],
      total: 0,
      filter: {q: '', client_id: null, limit: 100, offset: 0},
      load: true,
      timer: null,
      filters_state: this.localStorage.getItem('filters_state') !== 'false'
    }
  },
  computed: {
    client_list() {
      return this.$store.getters.getClientsList.map(client => ({id: client.id, label: client.name}))
    },
    sended_filter() {
      const filter = {}
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== '') {
          filter[key] = key === 'q' ? encodeURIComponent(this.filter[key]) : this.filter[key]
        }
      })
      return filter
    }
  },
  created() {
    this.load_groups()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    change_input() {
      clearTimeout(this.timer)
      this.filter.offset = 0
      this.timer = setTimeout(this.load_groups, 500)
    },
    change_page(offset) {
      clearTimeout(this.timer)
      this.filter.offset = offset
      this.load_groups()
    },
    load_groups() {
      this.load = true
      this.$http.simcard.getSimcardProfileGroupList(this.sended_filter, (response) => {
        this.groups = response.data.items
        this.total = response.data.total
        this.load = false
      })
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.profile_group_list {
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    gap: 10px;
    padding: 30px 10px 10px;
    .form_select {
      width: 260px;
    }
    .form-group {
      margin-bottom: 0;
    }
  }
  .response_table {
    padding: 0;
    th {
      font-size: 12px;
      &.text-left {
        text-align: left;
      }
    }
  }
  .pagination_controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
  }
}
</style>
